import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { SignUpComponent } from '../components/Auth/SignUpComponent';

export default function SignUp() {
  const navigate = useNavigate();
  
  const handleSuccess = () => {
    navigate('/login', { 
      state: { 
        signupSuccess: true,
        message: 'Bruker opprettet! Du kan nå logge inn med dine nye opplysninger.' 
      } 
    });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-xl shadow-md">
        <div>
          <img 
            src="/images/Condo-logo-dark.png" 
            alt="Condo" 
            className="h-12 mx-auto"
          />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Opprett ny bruker
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Fyll ut skjemaet under for å opprette en ny brukerkonto
          </p>
        </div>
        
        <div className="mt-8">
          <SignUpComponent onSuccess={handleSuccess} />
        </div>
        
        <div className="mt-4 text-center">
          <p className="text-sm text-gray-600">
            Har du allerede en konto?{' '}
            <Link to="/login" className="font-medium text-condo-dark hover:text-condo-med">
              Logg inn her
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}